export default "__VITE_ASSET__53e49d2b__"